
  import {Component, Vue} from "vue-property-decorator";
  import {IGateEventsLog} from "@/modules/barriers/interfaces/gate-events-log.interface";
  import {IApp} from "@/interfaces/app.interface";
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import AppDatePicker from "@/components/FormControls/AppDatePicker.vue";

  @Component({
    components: {
      AppDatePicker,
    }
  })
  export default class GateEventsLogFilters extends Vue {

    dateFormats = IApp.DateFormats;
    formModel: IGateEventsLog.IFilters = {
      carNumber: '',
      dateBeg: '',
      dateEnd: '',
      hours: [],
    };

    get hours() { let hours = []; for (let i = 0; i < 24; i++) { hours.push(i); } return hours; }

    setFilters() {
      this.$emit('setFilters', IReport.PrepareFilters(this.formModel as any));
    }

    validateValue() {
      this.formModel.carNumber = this.formModel.carNumber
        .replace(/[^0-9a-zа-яё\s]/gi, "")
        .trim()
        .slice(0, 10)
        .toUpperCase();
    }

    pickerShortcutAction(dates: { start?: string; end?: string; }) {
      if (dates.start) this.formModel.dateBeg = dates.start;
      if (dates.end) this.formModel.dateEnd = dates.end;
    }

  }
